<template>
     <back-layout title="Administração">
         <template #header>
            <div class="flex justify-between px-4 flex-col sm:flex-row">
                <h2 class="font-semibold text-2xl lg:text-4xl text-gray-300 leading-tight mb-4 md:mb-0">Definições</h2>
            </div>
        </template>

        <div class="container mx-auto px-4">
           <h3 class="font-bold">Estatísticas</h3>
           <div class="flex flex-col space-y-4 md:flex-row md:space-x-8 md:space-y-0">

                <div class="flex-1 bg-white overflow-hidden shadow rounded-lg p-10">
                    <p>Colocações</p>
                    <jet-input type="text" v-model="colocacoes" class="w-full" @focusout="updateText" id="stats_colocacoes"/>
                    <button class="my-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Atualizar</button>
                </div>

                <div class="flex-1 bg-white overflow-hidden shadow rounded-lg p-10">
                    <p>Parceiros</p>
                    <jet-input type="text" v-model="parceiros" class="w-full" @focusout="updateText" id="stats_parceiros"/>
                    <button class="my-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Atualizar</button>
                </div>

                <div class="flex-1 bg-white overflow-hidden shadow rounded-lg p-10">
                    <p>Oportunidades</p>
                    <jet-input type="text" v-model="oportunidades" class="w-full" @focusout="updateText" id="stats_oportunidades"/>
                    <button class="my-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Atualizar</button>
                </div>
               
           </div>

           
            
       
        </div>
    </back-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetInput from '@/Jetstream/Input.vue'
   

    export default defineComponent({
        components: {
            Head,
            Link,
            BackLayout,
            JetInput
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            stats_colocacoes: String,
            stats_parceiros: String,
            stats_oportunidades: String
        },
        data(){
            return {
                colocacoes: '',
                parceiros: '',
                oportunidades: '',
                form: this.$inertia.form({
                    setting: '',
                    content: '',
                    route: '',
                })
            }
        },
        mounted() {
            this.colocacoes = this.stats_colocacoes
            this.parceiros = this.stats_parceiros
            this.oportunidades = this.stats_oportunidades
        },
        methods: {
            updateText(e) {
                this.form.setting = e.target.id
                this.form.content = e.target.value,
                this.form.route = this.route().current()
                
            },
            updateSettings(e) {
                    this.form.post(route('update.settings'), {
                        preserveState: false,
                        preserveScroll: true,
                        onSuccess: () => {
                            this.form.reset(),
                            this.$page.props.flash.success = 'Estatística atualizada'
                        }, 
                    })

            },
        },
    })
</script>